import { motion } from "framer-motion";
import { ShieldCheck, Download } from "lucide-react";
import { NAV_LINKS, ONE_PAGER } from "./data";
import { scrollToId, EASE } from "./shared";

export default function Nav() {
  return (
    <motion.header
      initial={{ y: -64, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, delay: 0.2, ease: EASE }}
      className="fixed inset-x-0 top-0 z-50 border-b border-slate-800/80 bg-[#0A0E17]/80 backdrop-blur-xl"
    >
      <div className="mx-auto flex h-16 max-w-[1440px] items-center justify-between gap-4 px-5 lg:px-8">
        <button
          data-testid="nav-logo"
          onClick={() => scrollToId("top")}
          className="flex shrink-0 items-center gap-2 whitespace-nowrap text-left"
        >
          <ShieldCheck className="h-5 w-5 text-[#FF5500]" strokeWidth={2.2} />
          <span className="font-display text-lg font-semibold uppercase tracking-wide text-slate-100">
            WorkSafeAgent <span className="text-[#FF5500]">IR</span>
          </span>
        </button>

        <nav className="hidden items-center gap-4 lg:flex xl:gap-5" aria-label="Primary">
          {NAV_LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollToId(l.id)}
              className="whitespace-nowrap font-mono text-[11px] uppercase tracking-widest text-slate-400 transition-colors duration-200 hover:text-[#FF5500]"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex shrink-0 items-center gap-3">
          <span
            data-testid="nav-round-badge"
            className="hidden items-center gap-2 whitespace-nowrap rounded-full border border-[#FF5500]/40 bg-[#FF5500]/10 px-3 py-1 font-mono text-[11px] uppercase tracking-widest text-[#FF7A33] xl:flex"
          >
            <span className="relative flex h-1.5 w-1.5">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#FF5500] opacity-75" />
              <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-[#FF5500]" />
            </span>
            $250K Bridge
          </span>
          <a
            data-testid="nav-onepager-cta"
            href={ONE_PAGER.href}
            download
            className="flex items-center gap-2 whitespace-nowrap rounded-full bg-[#FF5500] px-4 py-2 font-mono text-xs font-semibold uppercase tracking-widest text-white transition-colors duration-200 hover:bg-[#E04B00]"
          >
            <Download className="h-3.5 w-3.5" />
            One-Pager
          </a>
        </div>
      </div>
    </motion.header>
  );
}
